const guiColors = {
    'motion-primary': '#ffee00',
    'motion-primary-transparent': '#ffee00d8',
    'motion-tertiary': '#fcff40',

    'looks-secondary': '#ffd700',
    'looks-transparent': '#ffd90059',
    'looks-light-transparent': '#fff34d26',
    'looks-secondary-dark': 'rgb(183, 176, 78)',

    'extensions-primary': 'rgb(242, 239, 90)',
    'extensions-tertiary': 'rgb(189, 177, 15)',
    'extensions-transparent': 'hsla(56, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#fffd8c'
}

const blockColors = {};

export {
    guiColors,
    blockColors
};